import { getEmailsByDocument } from "../../services/user";

const Types = {
  EMAILS_LOADED: '@AUTH/EMAILS_LOADED',  
  EMAILS_LOADING: '@AUTH/EMAILS_LOADING',
  RESET: '@AUTH/RESET'
}

const INITIAL_STATE = {
  emails: null,
  loading: false,
}

export default function reducers (state = INITIAL_STATE, { type, payload }) {
  switch(type) {
    case Types.EMAILS_LOADED:
      return { ...state, emails: payload, loading: false };
    case Types.EMAILS_LOADING:
      return { ...state, loading: true };
    case Types.RESET:
      return { ...state, ...INITIAL_STATE };
    default:
      return state;
  }
}

export const loadEmails = (document) => async (dispatch) => {
  dispatch(resetEmails());
  dispatch({ type: Types.EMAILS_LOADING });
  const data = await getEmailsByDocument(document);
  dispatch({
    type: Types.EMAILS_LOADED,
    payload: data.map((item) => ({
      value: item,
      label: item.email,
      key: item.key,
    }))
  });
}

export const resetEmails = () => ({ type: Types.RESET });
